import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import PageContent from "@my-dld/components/PageContent";
import { ServiceCard } from "@my-dld/components/ServiceContainer";
import { MyRequestsBCItem } from "@my-dld/contexts/PageContext";
import { showRequests } from "../../../NavigationUtils";
import { HTCountRequest, HTRoleType } from "../../../api/entities";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { verifyTenantUserProfile } from "@eres/ejari-web/component/TenantContract/PropertyDetails";
import { getParticipantID } from "@10x/sso";
import { getRequestsCount, validateResponse } from "../../../api/api";

interface Props extends RoutedViewProps {

}

interface State {
	services: ServiceCard[];
}

class RequestMain extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			services: Services,
		};
	}

	componentDidMount() {
		this.loadTenantProfile();
	}

	render() {
		const { services } = this.state;
		return <PageContent
			hideQLinks={ true }
			serviceTitle={ Strings.handover_takeover_requests }
			services={ services }>
			<PageTitle title={ Strings.handover_takeover_requests } paths={ [ MyRequestsBCItem ] }/>
		</PageContent>;
	}

	private loadTenantProfile() {
		showLoading();
		verifyTenantUserProfile().then( this.loadRequestsCount )
		.catch( this.loadRequestsCount );
	}

	private loadRequestsCount = ( tenantId?: number ) => {
		const req: HTCountRequest = {
			participantId: getParticipantID(),
			tenantId: tenantId,
		};
		getRequestsCount( req ).then( validateResponse ).then( response => {
			this.setState( {
				services: this.state.services.map( service => {
					if ( service.id === "ht_my_requests" ) {
						service.count = response.RequestCount;
					} else if ( service.id === "ht_requests_from_owner" ) {
						service.count = response.RequestCountFromOwner;
					}
					return service;
				} ),
			} );
			hideLoading();
		} ).catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	};
}

const handleServiceAction = ( id: string ) => {
	const role = ( id === "ht_my_requests" ) ? HTRoleType.OWNER : HTRoleType.TENANT;
	showRequests( "" + role );
};

const Services: ServiceCard[] = [
	{
		id: "ht_my_requests",
		label: LVStrings.my_requests,
		action: handleServiceAction,
		allowUnverifiedEmailUsers: true,
	},
	{
		id: "ht_requests_from_owner",
		label: LVStrings.requests_from_owner,
		action: handleServiceAction,
		allowUnverifiedEmailUsers: true,
	}
];

export default RequestMain;
